const rules = {
  numeric: {
    validator: /^[0-9]+$/,
    message: 'Not a valid number'
  },
  integer: {
    validator: /^-?[0-9]+$/,
    message: 'Not a valid Integer'
  },
  decimal: {
    validator: /^-?[0-9]*\.?[0-9]+$/,
    message: 'Not a valid decimal'
  },
  email: {
    validator: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    message: 'Not a valid email'
  },
  alpha: {
    validator: /^[a-z]+$/i,
    message: 'Not a valid alpha'
  },
  alphaNumeric: {
    validator: /^[a-z0-9]+$/i,
    message: 'Not a valid alpha numeric value'
  },
  alphaDash: {
    validator: /^[a-z0-9_-]+$/i,
    message: 'Not a valid alpha numeric dash value'
  },
  natural: {
    validator: /^[0-9]+$/i,
    message: 'Not a valid natural number'
  },
  naturalNoZero: {
    validator: /^[1-9][0-9]*$/i,
    message: 'Not a valid natural value'
  },
  ip: {
    validator: /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})$/i,
    message: 'Not a valid ip address'
  },
  base64: {
    validator: /[^a-zA-Z0-9/+=]/i,
    message: 'Not a valid base 64'
  },
  numericDash: {
    validator: /^[\d\-\s]+$/,
    message: 'Not a valid numeric dash'
  },
  url: {
    validator: /^((http|https):\/\/(\w+:{0,1}\w*@)?(\S+)|)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?$/,
    message: 'Not a valid url'
  },
  phoneUS: {
    validator: /^(1-?)?(\([0-9]\d{2}\)|[0-9]\d{2})[- ]?[0-9]\d{2}[- ]?\d{4}$/,
    message: 'Not a valid phone number'
  },
  zip: {
    validator: /(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/,
    message: 'Not a valid zip code'
  },
  // this is for usa and canada zip codes
  zipUSCA: {
    validator: /(^([0-9]{5})$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)/,
    message: 'Not a valid zip code'
  },
  required: (dependsOn, dependsValue)=>({
    validator: (value, data)=>{
      const _value = typeof value === 'number' ? value : (value || '').trim();
      if (dependsOn) {
        if ((!dependsValue && !data[dependsOn].value && arguments.length < 4) || (data[dependsOn].value !== dependsValue)) {
          return false;
        }
      }
      return !_value;
    },
    message: 'This field is required',
    empty: true
  }),
  match: (field, fieldName)=>({
    validator: (value, data) => {
      const isInvalid = value !== data[field];
      if(isInvalid){
        return `Field must match ${fieldName || field}`;
      }
      return isInvalid;

    },
  }),
  not: {
    validator(){
      return (value, data)=>{
        return args.indexOf(value) !== -1;
      }
    },
  },
  in: {
    validator(){
      return (value, data)=>{
        return args.indexOf(value) === -1;
      }
    },
  },
  between: {
    validator(min, max){
      return (value, data)=>{
        const l = value.length;
        return !(l >= min && l <= max);
      }
    },
  },
  min: {
    validator(min){
      return (value, data)=>{
        const l = value.length;
        return !(l >= min);

      }
    },
  },
  max: {
    validator(max){
      return (value, data)=>{
        const l = value.length;
        return !(l <= max);
      }
    },
  },
  length: {
    validator(length){
      return (value, data)=>{
        const len = value.length;
        return (len !== length);

      }
    },
  },
  cc: {
    validator(){
      return (value, data)=>{
        // Luhn Check Code from https://gist.github.com/4075533
        // accept only digits, dashes or spaces
        if (!rules.numericDash.validator.test(value)) {
          return true;
        }
        let nCheck = 0;
        let nDigit = 0;
        let bEven = false;
        const strippedField = value.replace(/\D/g, '');

        for (let n = strippedField.length - 1; n >= 0; n--) {
          const cDigit = strippedField.charAt(n);
          nDigit = parseInt(cDigit, 10);
          if (bEven) {
            // eslint-disable-next-line no-cond-assign
            if ((nDigit *= 2) > 9) {
              nDigit -= 9;
            }
          }

          nCheck += nDigit;
          bEven = !bEven;
        }

        return (nCheck % 10) !== 0;

      }
    },
  },
};

export default rules;




// WEBPACK FOOTER //
// ./src/app/components/Forms/rules.js